<template>
    <div class="m-0">
        <validation-provider
                :name="field.name"
                :rules="field.rules"
                v-slot="validationContext"
        >
            <b-form-group
                    :label-for="field.name"
                    :label="field.label + '\xa0'"
                    :id="'g_' + field.name"
                    class="mt-0"
            >
                <b-form-input
                        :placeholder="field.placeholder"
                        type="number"
                        v-model="data.value"
                        :state="getValidationState(validationContext)"
                        :id="field.name"
                        :disabled="field.readonly"
                ></b-form-input>
                <small v-if="field.hint" class="text-info">{{field.hint}}</small>
                <h6 class="text-right">{{field.textAfter}}&#8288;</h6>
            </b-form-group>
            <b-form-invalid-feedback
                    :id="'input-2-live-feedback' + field.name"
            >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
        </validation-provider>
    </div>
</template>

<script>
    export default {
        name: "IntInput",
        props: {
            field: { required: true},
            data: { required: true }
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
        }
    }
</script>

<style scoped>

</style>
